<template>
  <div style="text-align: center; margin-top: 170px">
    <img
      src="../assets/image/common/error404.png"
      style="width: 364px"
      alt=""
    />
    <div class="errorContent">
      页面将在<span style="color: #066eb7">{{ count }}</span
      >秒后回到首页
    </div>
  </div>
</template>

<script>
import { presentUrl } from "@/utils/config";

export default {
  data() {
    return {
      count: 3,
      isShowTimeHeader: 1,
      presentUrl,
    };
  },
  methods: {
    getTime() {
      const EndTime = 3;
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.count >= 1 && this.count <= EndTime) {
            this.count--;
            if (this.count == 0) {
              window.location.replace(this.presentUrl, "_self");
            }
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.isShowTimeHeader = 0;
          }
        }, 1000);
      }
    },
  },
  created() {
    this.getTime();
  },
};
</script>

<style></style>

<style lang="scss" scoped></style>
